import { CERelationshipAttributesBase } from './ce-relationship-attributes-base'


export class CERelationshipAttributes extends CERelationshipAttributesBase {

}